const root = ''
export default root

export const API_URL = ''



// WEBPACK FOOTER //
// ./src/components/shared/utils.js